import { useIntl } from 'react-intl'

import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import PropertyFacilitiesContent, { type PropertyFacilityGroup } from './PropertyFacilitiesContent'

type Props = {
  facilities: string
} | {
  amenities: Array<PropertyFacilityGroup>
}

function PropertyFacilitiesModal(props: Props) {
  const intl = useIntl()

  const modalTitle = intl.formatMessage({
    id: 'l9zqg_3glZLL7DlJxQv-',
    defaultMessage: 'Facilities',
  })

  return <Modal title={modalTitle} size="L">
    <BodyText variant="medium">
      <PropertyFacilitiesContent {...props} />
    </BodyText>
  </Modal>
}

export default PropertyFacilitiesModal
export type { PropertyFacilityGroup }
